import {
  SeatmapsStore,
  selectCurrentSeatmap,
} from '@des/store/seatmaps';
import {
  select,
} from '@ngrx/store';
import {
  Observable,
} from 'rxjs';
import {
  distinctUntilChanged,
  filter,
} from 'rxjs/operators';

/**
 * Returns a method which takes the source store as parameter and extracts the seatmap
 */
export const retrieveCurrentSeatmap = () => (source: Observable<SeatmapsStore>) =>
  source.pipe(
    filter((store) => !!store.seatmaps),
    select(selectCurrentSeatmap),
    distinctUntilChanged((a, b) => a?.id === b?.id && a?.selectedSeats.length === b?.selectedSeats.length && a?.seatmaps.length === b?.seatmaps.length)
  );
